
/**
 * 将 dom 元素全屏
 * @param {dom} element dom元素
 * @example
 * setFullscreen(document.documentElement) // 整个页面进入全屏
 * setFullscreen(document.getElementById("id")) // 某个元素进入全屏
 */
export function setFullScreen(element) {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullScreen();
  }
}

/**
 * 退出全屏
 * @example
 * exitFullscreen();
 */
export function exitFullScreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
}

/**
 * 从 window.location.href 中获取指定key的value
 * @param {*} key 要获取的 key
 * @returns window.location.href 中指定key对应的value
 * @example
 * const value = getUrlParam(key);
 */
export function getUrlParam(key) {
  const url = window.location.href.replace(/^[^?]*\?/, '');
  const regexp = new RegExp(`(^|&)${key}=([^&#]*)(&|$|)`, 'i');
  const paramMatch = url.match(regexp);

  return paramMatch ? paramMatch[2] : null;
}
export function isUndefined(value) {
  return value === 'undefined';
}

/**
 * 获取屏幕宽度分辨率
 * @param {*} value
 */
export function getVideoWidth(value) {
  const widthMap = new Map([
    // 流畅
    [0, 640],
    // 标清
    [1, 852],
    // 高清
    [2, 1280],
    // 超清
    [3, 1920],
  ]);
  return widthMap.get(value) ? widthMap.get(value) : 640;
}

/**
 * 获取屏幕高度分辨率
 * @param {*} value
 */
export function getVideoHeight(value) {
  const heightMap = new Map([
    // 流畅
    [0, 360],
    // 标清
    [1, 480],
    // 高清
    [2, 720],
    // 超清
    [3, 1080],
  ]);
  return heightMap.get(value) ? heightMap.get(value) : 360;
}

/**
 * 获取屏幕码率
 * @param {*} value
 */
export function getVideoBitrate(value) {
  const widthMap = new Map([
    // 流畅
    [0, 300],
    // 标清
    [1, 600],
    // 高清
    [2, 900],
    // 超清
    [3, 1500],
  ]);
  return widthMap.get(value) ? widthMap.get(value) : 300;
}
